@if(isEmailStillBeingSent) {
  <loading-animation [loadingMessage]="''"></loading-animation>
}

<div class="auth-flex-container">
  <div class="form-wrapper">
    @if(isPasswordResetFormSubmitted) {
      <div class="form-header-wrapper">
        <h2 class="form-header-text">Password reset request sent.</h2>
        <div class="left-aligned-text">
          <span>If an account exists for the email address entered, you should receive an email with a reset link within an hour. To reset your password, close this web browser and follow the instructions in your email.</span>
        </div>
      </div>
      <div class="form-content--reset-container">
        <div>
          <strong>{{this.entryForm.get('email').value | lowercase}}</strong>
        </div>
        <div class="extra-padding-topbottom">
          <a href="/site">Back to the Summit website</a>
        </div>
        <div>
          <span><strong>Didn't receive the email?</strong></span>
        </div>
        <div>
          <span>Please check your SPAM folder or <a href="/auth/forgotPassword">try completing the form again.</a></span>
        </div>
      </div>
    } @else {
      <div class="form-header-wrapper">
        <h2 class="form-header-text">Recover your password.</h2>
        <div class="left-aligned-text">
          <div>Enter the email address for your account below and click submit. </div>
          <div>If an account exists for that email, you will receive a password reset link.</div>
        </div>
      </div>
      <div id="content--email-wrapper">
        <form [formGroup]="entryForm">
          <mat-form-field appearance="outline" style="width: 100%">
            <mat-label><strong style="font-size: 15px;">Email Address</strong></mat-label>
            <input matInput #emailInput
                   [errorStateMatcher]="matcher"
                   type="email"
                   formControlName="email"
                   maxlength="100">
            @if (entryForm.controls.email.invalid) {
              <mat-error>{{entryForm.controls.email.hasError('required') ? 'Email is required' : 'Email is not valid.'}}</mat-error>
            }
          </mat-form-field>
        </form>
      </div>
      <div class="buttons-wrapper">
        <div class="button-group-full-width">
          <button mat-flat-button
                  color="primary"
                  [disabled]="isEmailStillBeingSent || entryForm.controls.email.invalid || !this.entryForm.get('email').value"
                  (click)="onSubmitClicked()"
                  type="button">Submit
          </button>
          <button mat-stroked-button
                  color="primary"
                  (click)="onCancelClicked()">Cancel
          </button>
        </div>
      </div>
    }
  </div>
</div>
